var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-4 text-right"},[(_vm.errors.length)?_c('span',{staticClass:"text-sm",class:[_vm.aggressiveErrorDisplay ? 'text-red-400': 'text-gray-400 text-light']},[_vm._v(" "+_vm._s(_vm.errors[0])+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }